import { Component, OnInit } from '@angular/core';
import { PlmService } from 'src/app/shared/services/plm.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-plm-resource-map',
  templateUrl: './plm-resource-map.component.html',
  styleUrls: ['../plm-shared.css'],
})
export class PlmResourceMapComponent implements OnInit {
  projects: any[] = [];
  locations: any[] = [];
  projectId: number | null = null;
  resources: any[] = [];
  tools: any[] = [];
  toolIssues: any[] = [];
  consumables: any[] = [];
  contractors: any[] = [];
  mapForm: any = { work_location_id: '', crew_label: '', machine_id: '', tool_id: '', shift: 'day' };
  toolForm: any = { tool_code: '', tool_name: '', category: '', uom: 'nos' };
  issueForm: any = { tool_id: '', qty: 1, issued_to: '', work_location_id: '' };
  consForm: any = { material_id: '', qty: '', uom: 'cum', work_location_id: '' };
  contractorForm: any = { vendor_id: '', package_code: '', role: 'contractor', work_location_id: '' };

  constructor(private plm: PlmService, private api: ApiService, private toastr: ToastrMsgService) {}

  ngOnInit(): void {
    this.api.getProjectCommonAll({ page: 1, limit: 200 }).subscribe({
      next: (res: any) => (this.projects = res?.data || []),
    });
    this.reload();
  }

  onProject(): void {
    this.plm.listWorkLocations({ project_id: this.projectId || undefined }).subscribe({
      next: (r: any) => (this.locations = r.data || []),
    });
    this.reload();
  }

  reload(): void {
    const q = { project_id: this.projectId || undefined };
    this.plm.listResourceMap(q).subscribe({ next: (r: any) => (this.resources = r.data || []) });
    this.plm.listTools().subscribe({ next: (r: any) => (this.tools = r.data || []) });
    this.plm.listToolIssues(q).subscribe({ next: (r: any) => (this.toolIssues = r.data || []) });
    this.plm.listConsumables(q).subscribe({ next: (r: any) => (this.consumables = r.data || []) });
    this.plm.listContractors(q).subscribe({ next: (r: any) => (this.contractors = r.data || []) });
  }

  addMap(): void {
    this.plm.createResourceMap({ ...this.mapForm, project_id: this.projectId }).subscribe({
      next: () => {
        this.toastr.success('Resource mapped');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  addTool(): void {
    this.plm.createTool(this.toolForm).subscribe({
      next: () => {
        this.toastr.success('Tool added');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  issueTool(): void {
    this.plm.createToolIssue({ ...this.issueForm, project_id: this.projectId }).subscribe({
      next: () => {
        this.toastr.success('Tool issued');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  issueConsumable(): void {
    this.plm.createConsumable({ ...this.consForm, project_id: this.projectId }).subscribe({
      next: () => {
        this.toastr.success('Consumable issued');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  addContractor(): void {
    this.plm.createContractor({ ...this.contractorForm, project_id: this.projectId }).subscribe({
      next: () => {
        this.toastr.success('Contractor assigned');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }
}
